import { ApolloQueryResult } from '@apollo/client/core';
import { Injectable, inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { GET_CLOSURES } from '@riise/graphql/closures/closures.queries';




@Injectable({
  providedIn: 'root',
})
export class ClosuresService {

  private apollo = inject(Apollo);


  private clotureDate: Date | null = null;



  // Cette méthode est appelée après le login ou récupération depuis l'API
  setCloture(dateString: string) {
    this.clotureDate = new Date(dateString);
  }


  getCloture(): Date | null {
    return this.clotureDate;
  }


  // Vérifie si une date est bloquée
  blockedDate(dateEntry: Date): boolean {
    if (!this.clotureDate) return false;
    return dateEntry <= this.clotureDate;
  }



  // Donne la date formatée pour un input type="date"
  getClotureAsString(): string | null {
    return this.clotureDate?.toISOString().split('T')[0] || null;
  }



  getClotureActive(isActive: boolean | null = null) {
    return this.apollo.watchQuery<any>({
        query: GET_CLOSURES,
        fetchPolicy: 'no-cache', // or 'network-only'
        variables: {
          isActive: isActive,
        },
    }).valueChanges;
  }


}
